import { Button, Stack } from '@mui/material';

import { SAUDI_REWARDS_EDIT_ACCOUNT_URL } from 'constants/saudi-rewards.constants';
import { useModalControl } from 'hooks/useModalControl';

import SettingsLink from 'components/@account/SettingsLink';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import SaudiRewardsUnlinkAccount from 'components/@saudi-rewards/SaudiRewardsUnlinkAccount';

interface Props {
  onCloseCheckBalance: () => void;
}

const SettingLinksList = ({ onCloseCheckBalance }: Props) => {
  const {
    open: unlinkOpen,
    onClose: unlinkOnClose,
    onOpen: unlinkOnOpen,
  } = useModalControl();

  return (
    <Stack
      sx={{
        gap: 1,
        mt: 3,
      }}
    >
      <SettingsLink
        iconName="Edit"
        intlId="account.settings.edit.saudi.rewards.account"
        component={LinkUnstyled}
        href={SAUDI_REWARDS_EDIT_ACCOUNT_URL}
        target="_blank"
      />
      <SettingsLink
        iconName="Unlink"
        intlId="account.settings.unlink.saudi.rewards.account"
        component={Button}
        onClick={unlinkOnOpen}
      />
      <SaudiRewardsUnlinkAccount
        open={unlinkOpen}
        onSuccess={() => {
          unlinkOnClose();
          onCloseCheckBalance();
        }}
        onClose={unlinkOnClose}
      />
    </Stack>
  );
};

export default SettingLinksList;
